<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
const PpdShopTop = () => import('@/components/organisms/PpdShopTop.vue')

const nuxtApp = useNuxtApp()
const { $router, nuxt2Context } = nuxtApp
const { localePath, route }: any = nuxt2Context

onBeforeMount(() => {
  if (route.query?.status == 'success') {
    $router.push(
      localePath({
        path: '/market/shop/ppdshop/purchaseppd',
        query: route.query,
      })
    )
  }
})

</script>

<template>
  <div class="mt-2">
    <PpdShopTop />
    <nuxt-child />
  </div>
</template>
